import React, { createContext, ReactNode, useContext, useState } from "react";
import { RateImportPaginationRequest } from "@/main/models/request";
import { RateImportResponse } from "@/main/models/response";

interface BodyshopRateContextType {
	dataGrid: RateImportResponse[];
	setDataGrid: React.Dispatch<React.SetStateAction<RateImportResponse[]>>;
	formFilters: RateImportPaginationRequest | null;
	setFormFilters: React.Dispatch<React.SetStateAction<RateImportPaginationRequest | null>>;
	getDataSearch: (filters: RateImportPaginationRequest) => void;
	onResetSearch: () => void;
	showFilters: boolean;
	setShowFilters: React.Dispatch<React.SetStateAction<boolean>>;
}

const BodyshopRateContext = createContext<BodyshopRateContextType | undefined>(undefined);

export function BodyshopRateProvider({ children }: { children: ReactNode }) {
	const [dataGrid, setDataGrid] = useState<RateImportResponse[]>([]);
	const [showFilters, setShowFilters] = useState<boolean>(true);
	const [formFilters, setFormFilters] = useState<RateImportPaginationRequest | null>(null);

	function getDataSearch(filters: RateImportPaginationRequest) {
		setFormFilters(filters);
		setDataGrid([]);
	}

	function onResetSearch() {
		setFormFilters(null);
		setDataGrid([]);
	}

	return (
		<BodyshopRateContext.Provider
			value={{
				dataGrid,
				setDataGrid,
				formFilters,
				setFormFilters,
				getDataSearch,
				onResetSearch,
				showFilters,
				setShowFilters,
			}}
		>
			{children}
		</BodyshopRateContext.Provider>
	);
}

export function useBodyshopRateContext() {
	const context = useContext(BodyshopRateContext);
	if (!context) {
		throw new Error("useBodyshopRateContext must be used within a BodyshopRateProvider");
	}
	return context;
}
